import { get } from '~/util/api/get'
import { post } from '~/util/api/post'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logout = (): Promise<any> => post('/api/user/logout')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkLoggedIn = (): Promise<any> => get('/api/user/current-stable-anonymous')

export { logout, checkLoggedIn }
